export enum IActionItemMenuOptions {
  'Go to Item' = 1,
  'Remove Item',
  'Cancel',
}
